module.exports = __webpack_public_path__ + "img/canvasMenu9.521086ce.svg";